<div class="pagetitle">
  <h2>Audit Logs</h2>
</div>

<form class="form-row align-items-end" (ngSubmit)="apply()">
  <div class="col-sm-6 col-md mb-2">
    <label for="audit-entity" class="small mb-0">Entity</label>
    <select id="audit-entity" name="entity" class="form-control form-control-sm" [(ngModel)]="filters.entity">
      <option value="">All</option>
      @for (e of entities; track e) {
        <option [value]="e">{{ entityLabels[e] }}</option>
      }
    </select>
  </div>
  <div class="col-sm-6 col-md mb-2">
    <label for="audit-action" class="small mb-0">Action</label>
    <select id="audit-action" name="action" class="form-control form-control-sm" [(ngModel)]="filters.action">
      <option value="">All</option>
      @for (a of actions; track a) {
        <option [value]="a">{{ actionLabels[a] }}</option>
      }
    </select>
  </div>
  <div class="col-sm-6 col-md mb-2">
    <label for="audit-actor" class="small mb-0">Actor</label>
    <select id="audit-actor" name="actor" class="form-control form-control-sm" [(ngModel)]="filters.actor">
      <option value="">All</option>
      <option value="system">System</option>
      @for (actor of actors; track actor.email) {
        <option [value]="actor.email">{{ actor.email }}</option>
      }
    </select>
  </div>
  <div class="col-sm-6 col-md mb-2">
    <label for="audit-record" class="small mb-0">Record id</label>
    <input id="audit-record" name="record" type="text" class="form-control form-control-sm" placeholder="Id, or a sign-in's email" [(ngModel)]="filters.record">
  </div>
  <div class="col-sm-6 col-md mb-2">
    <label for="audit-from" class="small mb-0">From</label>
    <input id="audit-from" name="from" type="date" class="form-control form-control-sm" [(ngModel)]="filters.from">
  </div>
  <div class="col-sm-6 col-md mb-2">
    <label for="audit-to" class="small mb-0">To</label>
    <input id="audit-to" name="to" type="date" class="form-control form-control-sm" [(ngModel)]="filters.to">
  </div>
  <div class="col-md-auto mb-2">
    <button type="submit" class="btn btn-sm btn-primary">Apply</button>
    <button type="button" class="btn btn-sm btn-outline-secondary ml-1" (click)="clear()">Clear</button>
    <button type="button" class="btn btn-sm btn-success ml-1" [disabled]="exporting" (click)="exportCsv()">Export CSV</button>
  </div>
</form>

<div class="table-responsive">
  <table class="table table-bordered table-striped table-sm table-hover" width="100%" cellspacing="0">
    <thead>
      <tr>
        <th class="sort-na">Time</th>
        <th class="sort-na">Actor</th>
        <th class="sort-na">Action</th>
        <th class="sort-na">Entity</th>
        <th class="sort-na">Record</th>
        <th class="sort-na">Changes</th>
        <th class="sort-na"></th>
      </tr>
    </thead>
    <tbody>
      @if (loading) {
        <tr><td colspan="7" class="loading text-center">Loading...</td></tr>
      } @else {
        @for (log of logs; track log.id) {
          <tr>
            <td>{{ log.createdAt | date:'medium' }}</td>
            <td>{{ log.actor?.email || 'System' }}</td>
            <td><span class="badge" [ngClass]="actionBadges[log.action] || 'badge-secondary'">{{ actionLabels[log.action] || log.action }}</span></td>
            <td>{{ entityLabels[log.entity] || log.entity }}</td>
            <td>{{ log.entityId }}</td>
            <td>{{ changesSummary(log) }}</td>
            <td class="text-center"><button type="button" class="btn btn-edit btn-xs" (click)="showDetails(log)">Details</button></td>
          </tr>
        } @empty {
          <tr><td colspan="7" class="text-center">{{ msg || 'No audit log entries' }}</td></tr>
        }
      }
    </tbody>
  </table>
</div>

@if (count) {
  <div class="d-flex align-items-center">
    <span class="mr-3">Showing {{ offset + 1 }}-{{ offset + logs.length }} of {{ count | number }}</span>
    <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="offset === 0" (click)="paginate(-1)">Previous</button>
    <button type="button" class="btn btn-sm btn-outline-secondary ml-1" [disabled]="offset + limit >= count" (click)="paginate(1)">Next</button>
  </div>
}

<ng-template #details let-modal>
  <div class="modal-header">
    <h3 class="modal-title">Audit log entry</h3>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <dl class="row mb-0">
      <dt class="col-sm-2">Action</dt><dd class="col-sm-10">{{ actionLabels[selected.action] || selected.action }}</dd>
      <dt class="col-sm-2">Entity</dt><dd class="col-sm-10">{{ entityLabels[selected.entity] || selected.entity }}</dd>
      <dt class="col-sm-2">Record</dt><dd class="col-sm-10">{{ selected.entityId }}</dd>
      <dt class="col-sm-2">Actor</dt><dd class="col-sm-10">{{ selected.actor?.email || 'System' }}</dd>
      <dt class="col-sm-2">Time</dt><dd class="col-sm-10">{{ selected.createdAt | date:'medium' }}</dd>
    </dl>
    @if (selected.changes) {
      <h4 class="h6 mt-3">Changes</h4>
      <ul>
        @for (change of selected.changes | keyvalue; track change.key) {
          <li><b>{{ change.key }}</b>: {{ change.value.from | json }} &rarr; {{ change.value.to | json }}</li>
        }
      </ul>
    }
    <h4 class="h6 mt-3">Before</h4>
    <pre class="bg-light p-2 small">{{ selected.before | json }}</pre>
    <h4 class="h6">After</h4>
    <pre class="bg-light p-2 small">{{ selected.after | json }}</pre>
  </div>
</ng-template>
